import { PropTypes } from "prop-types";

const RefShape = PropTypes.shape({
  $ref: PropTypes.string.isRequired
});

export const LoggedInUserShape = PropTypes.shape({
  loading: PropTypes.bool.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  $uri: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired
});

export const UserShape = PropTypes.shape({
  $uri: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  groups: PropTypes.arrayOf(RefShape)
});

export const GroupShape = PropTypes.shape({
  $uri: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

export const RoleShape = PropTypes.shape({
  $uri: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  permissions: PropTypes.arrayOf(RefShape)
});

export const ProductShape = PropTypes.shape({
  $uri: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
});

export const ServiceShape = PropTypes.shape({
  $uri: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  pending: PropTypes.bool.isRequired,
  product: RefShape
});

export const ServiceDetailsShape = PropTypes.shape({
  $uri: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  pending: PropTypes.bool.isRequired,
  product: ProductShape
});

export const ResourceShape = PropTypes.shape({
  $uri: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  service: RefShape.isRequired,
  type: RefShape.isRequired
});

export const ResourceTypeShape = PropTypes.shape({
  $uri: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  is_global: PropTypes.bool.isRequired,
  added_version: PropTypes.string,
  removed_version: PropTypes.string,
  product: RefShape
});

export const PolicyShape = PropTypes.shape({
  $uri: PropTypes.string,
  id: PropTypes.string,
  user: RefShape,
  group: RefShape,
  resource: RefShape,
  role: RefShape,
  service: RefShape
});

export const PolicyDetailsShape = PropTypes.shape({
  $uri: PropTypes.string,
  id: PropTypes.string,
  user: UserShape,
  group: GroupShape,
  resource: ResourceShape,
  role: RoleShape,
  service: ServiceShape,
  product: ProductShape,
  resourceType: ResourceTypeShape,
  requiresUpdate: PropTypes.bool,
  requiresDelete: PropTypes.bool
});

export const PermissionShape = PropTypes.shape({
  $uri: PropTypes.string.isRequired,
  added_version: PropTypes.string,
  description: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  removed_version: PropTypes.string,
  resource_type: RefShape,
  summary: PropTypes.string.isRequired
});

export const EntityShape = PropTypes.shape({
  $uri: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["group", "user"]).isRequired,
  policies: PropTypes.arrayOf(PolicyShape).isRequired
});

export const OptionShape = PropTypes.shape({
  key: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
});
